import { NgModule } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ChartsModule } from '../../shared/charts/charts.module';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../global/pipes/pipes.module';
import { EsgComponent } from './esg.component';
import { EsgEffects } from './esg.effects';
import { TabsModule } from 'atlas-tabs';
import { TableModule } from 'atlas-table';
import { CdkModule } from 'atlas-cdk';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { FieldModule } from 'atlas-field';
import { LegacyModule } from 'atlas-legacy';
import { PaginationModule } from 'atlas-pagination';
import { TooltipModule } from 'atlas-tooltip';

export const COMPONENTS = [
    EsgComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // MercerOSModule,
        ChartsModule,
        SharedModule,
        PipesModule,
        TabsModule,
        TableModule,
        CdkModule,
        IconModule,
        ButtonModule,
        FieldModule,
        LegacyModule,
        PaginationModule,
        TooltipModule,
        EffectsModule.forFeature([EsgEffects])
    ],
    exports: COMPONENTS,
    providers: [DecimalPipe],
    bootstrap: [],
})
export class EsgModule {
}
